import actions from "./actions";

const initState = {
    createBulkAdditionalServiceLoading: false,
    createBulkAdditionalServiceError: null,
    createBulkAdditionalServiceMessage: null,

    getAdditionalServiceLoading: false,
    getAdditionalServiceError: null,
    getAdditionalServiceMessage: null,
    getAdditionalServiceData: [],

};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.GET_ADDITIONAL_SERVICE:
            return {
                ...state,
                getAdditionalServiceLoading: true,
                getAdditionalServiceError: null,
                getAdditionalServiceMessage: null,
                getAdditionalServiceData: [],
            };
        case actions.GET_ADDITIONAL_SERVICE_SUCCESS:
            return {
                ...state,
                getAdditionalServiceLoading: false,
                getAdditionalServiceError: null,
                getAdditionalServiceMessage: action.payload.message,
                getAdditionalServiceData: action.payload.data,
            };
        case actions.GET_ADDITIONAL_SERVICE_FAILED:
            return {
                ...state,
                getAdditionalServiceLoading: false,
                getAdditionalServiceError: action.payload.error,
                getAdditionalServiceMessage: null,
                getAdditionalServiceData: [],
            };


        case actions.CREATE_BULK_ADDITIONAL_SERVICE:
            return {
                ...state,
                createBulkAdditionalServiceLoading: true,
                createBulkAdditionalServiceError: null,
                createBulkAdditionalServiceMessage: null,
            };
        case actions.CREATE_BULK_ADDITIONAL_SERVICE_SUCCESS:
            return {
                ...state,
                createBulkAdditionalServiceLoading: false,
                createBulkAdditionalServiceError: null,
                createBulkAdditionalServiceMessage: action.payload.message,
            };
        case actions.CREATE_BULK_ADDITIONAL_SERVICE_FAILED:
            return {
                ...state,
                createBulkAdditionalServiceLoading: false,
                createBulkAdditionalServiceError: action.payload.error,
                createBulkAdditionalServiceMessage: null,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                createBulkAdditionalServiceError: null,
                createBulkAdditionalServiceMessage: null,
            };

        default:
            return state;
    }
}